import map from 'lodash/map';
import groupActions from '../../entities/groups/actions';

export const TYPES = {
  LOAD_REQUEST: 'groupSearch/LOAD_REQUEST',
  LOAD_REQUEST_SUCCESS: 'groupSearch/LOAD_REQUEST_SUCCESS',
  LOAD_REQUEST_ERROR: 'groupSearch/LOAD_REQUEST_ERROR',
  CLEAR_STATE: 'groupSearch/CLEAR_STATE',
};

export const search = (options, clearOldState) => async (dispatch) => {
  dispatch({ type: TYPES.LOAD_REQUEST });

  try {
    const response = await dispatch(groupActions.search(options));
    const { data, ...pagination } = response;

    const payload = {
      groupIds: map(data, group => group.id),
      pagination,
    };

    dispatch({ type: TYPES.LOAD_REQUEST_SUCCESS, payload, clearOldState });
  } catch (error) {
    dispatch({ type: TYPES.LOAD_REQUEST_ERROR, payload: error });
  }
};

export const clearState = (dispatch) => {
  dispatch({ type: TYPES.CLEAR_STATE });
};

export default {
  TYPES,
  search,
  clearState,
};
